export enum CanvasEditorView {
    MASTERS = 'masters',
    ARTBOARDS = 'artboards',
    VARIANTS = 'variants',
  }

export default CanvasEditorView;
